import * as React from "react"

const FileIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.2193 10.4175L9.6214 16.0155C8.15693 17.4799 5.78256 17.4799 4.3181 16.0155V16.0155C2.85363 14.551 2.85363 12.1766 4.3181 10.7122L11.0945 3.93573C12.0708 2.95942 13.6538 2.95942 14.6301 3.93574V3.93574C15.6064 4.91205 15.6064 6.49496 14.6301 7.47127L7.76945 14.3319C7.2813 14.82 6.48984 14.82 6.00169 14.3319V14.3319C5.51353 13.8437 5.51353 13.0523 6.00169 12.5641L11.6838 6.88201"
      stroke="#051711"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
  </svg>
)
export default FileIcon
